import { useState } from "react";
import { History } from "lucide-react";
import { AutoGrowTextarea } from "@/components/AutoGrowTextarea";
import { Popover, PopoverAnchor, PopoverContent } from "@/components/ui/popover";

export const ProjectTaskField = ({ index, value, suggestions, onChange, disabled, placeholder, testPrefix = "entry-project" }) => {
  const [open, setOpen] = useState(false);
  const q = (value || "").trim().toLowerCase();
  const exact = suggestions.some((s) => s.toLowerCase() === q);
  const matches = suggestions.filter((s) => s.toLowerCase() !== q && (!q || exact || s.toLowerCase().includes(q)));
  return (
    <Popover open={open && !disabled && matches.length > 0}>
      <PopoverAnchor asChild>
        <div>
          <AutoGrowTextarea
            data-testid={`${testPrefix}-${index}`}
            value={value}
            disabled={disabled}
            placeholder={placeholder}
            onChange={(ev) => onChange(ev.target.value)}
            onFocus={() => setOpen(true)}
            onBlur={() => setOpen(false)}
          />
        </div>
      </PopoverAnchor>
      <PopoverContent
        align="start"
        sideOffset={4}
        data-testid={`${testPrefix}-suggestions-${index}`}
        onOpenAutoFocus={(e) => e.preventDefault()}
        onCloseAutoFocus={(e) => e.preventDefault()}
        className="max-h-56 w-[var(--radix-popover-trigger-width)] min-w-[200px] overflow-auto p-1"
      >
        <div className="flex items-center gap-1.5 px-2 py-1 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
          <History className="h-3 w-3" /> Recent
        </div>
        {matches.map((s, j) => (
          <button
            key={s}
            type="button"
            data-testid={`${testPrefix}-suggestion-${index}-${j}`}
            onMouseDown={(ev) => { ev.preventDefault(); onChange(s); setOpen(false); }}
            className="block w-full rounded px-2 py-1.5 text-left text-sm leading-snug transition-colors hover:bg-secondary"
          >
            {s}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
};
